
export class StudentHighSchool {
  name: string;
  country?: string;
  city?: string;
  startYear: number;
  endYear?: number;
}
